import React from 'react'
import { ReactComponent } from './CircleTruckIcon.svg'
import { MergeReactElementProps } from '../../types'

interface CircleTruckIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', CircleTruckIconProps>

export const CircleTruckIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent stroke={color} ref={ref} {...props} />
  }
)
